export default {
  male: 'male',
  female: 'female',
} as const;
